import type { FC, SVGProps } from "react"

import { studioToScreen } from "@logic/lib/design"
import type { Face2dComputed, Edge2dComputed } from "@logic/lib/mesh"
import { useRecoilValue } from "recoil"

import { zoomState } from "~/containers/LegacyDesigner/state/view"
import { getRainbow, wrapInto } from "~/utils/getRainbow"

export const Faces: FC<{
  faces: Face2dComputed[]
  makeProps?: (options: {
    segment: Edge2dComputed
    groupIdx: number
    memberIdx: number
  }) => SVGProps<SVGLineElement>
}> = ({ faces, makeProps }) => {
  const zoom = useRecoilValue(zoomState)

  return (
    <>
      {faces.map(({ nodes: points }, i, { length }) => {
        return (
          <g key={JSON.stringify(faces) + i}>
            {points.map((point1, j) => {
              const point2 = wrapInto(j + 1, points)
              const screenPoint1 = studioToScreen.point(point1, zoom)
              const screenPoint2 = studioToScreen.point(point2, zoom)
              const additionalProps = makeProps?.({
                segment: { p1: point1, p2: point2 },
                groupIdx: i,
                memberIdx: j,
              })

              return (
                <line
                  key={JSON.stringify(point1) + j}
                  x1={screenPoint1.x}
                  y1={screenPoint1.y}
                  x2={screenPoint2.x}
                  y2={screenPoint2.y}
                  {...additionalProps}
                />
              )
            })}
          </g>
        )
      })}
    </>
  )
}

export const RainbowFaces: FC<{
  faces: Face2dComputed[]
}> = ({ faces }) => (
  <Faces
    faces={faces}
    makeProps={({ groupIdx }) => {
      const stroke = getRainbow(groupIdx)
      const strokeWidth = (faces.length - groupIdx + 1) * 3
      const opacity = (90 - strokeWidth * 2) / 100

      return {
        stroke,
        strokeWidth,
        opacity,
      }
    }}
  />
)
